import type { DaoError } from "@/data/dao/service/BaseServiceDao";
import { exceptionTypes } from "@/data/util/Config";



import { translations } from "@/shared/localization/translations";



import { type IPopupSettings, Popup } from "@/components/dialog/Popup";



import { trans } from "@/operator/localization/Trans";


export async function onApplyDiscountErrorOccurred(
    error: DaoError,
    settings: IPopupSettings = {},
    parent: JQuery = $(".app"),
    noItemsSelectedMessage: string | undefined = undefined
) {
    let popupSettings: IPopupSettings = {};
    if (
        error.type === exceptionTypes.voucherWithCodeNotExistsException ||
        error.type === exceptionTypes.discountWithCodeNotExistsException
    ) {
        popupSettings = { message: trans.voucher.invalidCode };
    } else if (error.type === exceptionTypes.nothingToDiscountException) {
        popupSettings = { message: trans.voucher.nothingToDiscount };
    } else if (
        error.type === exceptionTypes.voucherExpiredException ||
        error.type === exceptionTypes.discountExpiredException
    ) {
        popupSettings = { message: trans.voucher.codeExpired };
    } else if (error.type === exceptionTypes.voucherNotEnabledException) {
        popupSettings = { message: trans.voucher.invalidCode };
    } else if (
        error.type === exceptionTypes.voucherNotApplicableException ||
        error.type === exceptionTypes.discountNotApplicableException
    ) {
        popupSettings = { message: trans.voucher.codeNotApplicable };
    } else if (error.type === exceptionTypes.voucherUsedException) {
        popupSettings = { message: trans.voucher.codeUsed };
    } else if (
        error.type === exceptionTypes.voucherCodeAlreadyAppliedToCartException ||
        error.type === exceptionTypes.voucherCodeAlreadyAppliedToBillException ||
        error.type === exceptionTypes.discountCodeAlreadyAppliedToCartException ||
        error.type === exceptionTypes.discountCodeAlreadyAppliedToBillException
    ) {
        popupSettings = { message: trans.voucher.voucherCodeAlreadyApplied };
    } else if (
        error.type === exceptionTypes.billInvalidSelectionException ||
        error.type === exceptionTypes.billIsEmptyException
    ) {
        popupSettings = { message: translations.pay.failedBillInvalidSelection };
    } else if (error.type === exceptionTypes.billNoSelectedItemsException) {
        popupSettings = { message: noItemsSelectedMessage || translations.pay.failedBillInvalidSelection };
    } else if (error.type === exceptionTypes.billDoesNotAcceptDiscountsAfterFirstPaymentException) {
        popupSettings = { message: trans.discounts.billDoesNotAcceptDiscountsAfterFirstPaymentError };
    } else {
        popupSettings = {
            title: trans.general.error,
            message: error.message,
        };
    }

    Popup.show(
        {
            ...settings,
            ...popupSettings,
        },
        parent
    );
}
